import { instance as axios } from '../http'
import {
  INCIDENT_REASSONS,
  SUPPLIER_EFFECTIVE_STATUS_FILTER,
  ORDERS_EFFECTIVE_STATUS
} from '../endpoints'

const getIncidentReassons = (params = 'INCIDENCE') => axios.get(`${INCIDENT_REASSONS}${params}`)
const getRescheduleReassons = (params = 'RESCHEDULE_REASON') => axios.get(`${INCIDENT_REASSONS}${params}`)
const getStates = () => axios.get(SUPPLIER_EFFECTIVE_STATUS_FILTER)
const getDeliveredEffectiveStatus = () =>
  axios.get(ORDERS_EFFECTIVE_STATUS)

export default {
  getIncidentReassons,
  getRescheduleReassons,
  getStates,
  getDeliveredEffectiveStatus
}



// WEBPACK FOOTER //
// ./src/repository/api/filters.js